function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#e0e0e0",
      fillOpacity: 1
    },
    d: "M 30 26.667969 C 30 28.507812 28.507812 30 26.667969 30 L 3.332031 30 C 1.492188 30 0 28.507812 0 26.667969 L 0 3.332031 C 0 1.492188 1.492188 0 3.332031 0 L 26.667969 0 C 28.507812 0 30 1.492188 30 3.332031 Z M 30 26.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.398438 5.300781 C 23.433594 4.675781 22.144531 4.949219 21.519531 5.914062 L 12.445312 19.898438 L 8.253906 16.023438 C 7.710938 15.503906 6.929688 15.320312 6.210938 15.539062 C 5.496094 15.761719 4.949219 16.347656 4.789062 17.082031 C 4.625 17.816406 4.871094 18.578125 5.425781 19.082031 L 11.433594 24.636719 C 11.835938 25.007812 12.34375 25.191406 12.847656 25.191406 C 13.410156 25.191406 14.125 24.957031 14.597656 24.242188 C 14.875 23.820312 25.015625 8.183594 25.015625 8.183594 C 25.640625 7.21875 25.367188 5.929688 24.398438 5.300781 Z M 24.398438 5.300781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizCheckbox);
export default __webpack_public_path__ + "static/media/quiz_checkbox.23e0addff590e3c0c209c1ef0fd6c606.svg";
export { ForwardRef as ReactComponent };